// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import surveyResultEntity from './entities/survey-result.json';
import surveyResultMenu from '../pages/survey-result/menu.json';
import surveyResultFullForm from '../pages/survey-result/forms/full.json';
import surveyResultContextForm from '../pages/survey-result/forms/context.json';
import surveyResultMiniForm from '../pages/survey-result/forms/mini.json';
import surveyResultLookupForm from '../pages/survey-result/forms/lookup.json';
import surveyResultTableView from '../pages/survey-result/views/table.json';
import surveyResultCardsView from '../pages/survey-result/views/cards.json';
import surveyResultDashboardView from '../pages/survey-result/views/dashboard.json';

/** Тип запису «Результат опитування» зі сторінками пакета: меню, форми та подання з pages/survey-result/. */
export const surveyResultDefinition: IRecordTypeDefinition = {
  ...surveyResultEntity,
  views: assembleViewSet({
      table: surveyResultTableView,
      cards: surveyResultCardsView,
      dashboard: surveyResultDashboardView,
  }),
  form: surveyResultFullForm,
  forms: { full: surveyResultFullForm, context: surveyResultContextForm, mini: surveyResultMiniForm, lookup: surveyResultLookupForm },
  menu: surveyResultMenu,
} as IRecordTypeDefinition;
